module.exports = __webpack_public_path__ + "static/media/0007_Medium.bc002659.jpg";